<form (ngSubmit)="lagre()" [formGroup]="skjema">
  <inline-skjema>
    <inline-skjema-tittel>{{ 'Rediger gruppe' | translate }}</inline-skjema-tittel>

    <div class="kontainer">
      <gruppe-logo-og-farge-skjema [skjema]="skjema.controls.logoOgFarge" [gruppe]="gruppe()" />
      <fieldset>
        @if (skjema.value.erMal) {
          <mat-form-field>
            <mat-label>{{ 'Malnavn'|translate }}</mat-label>
            <input matInput [formControl]="skjema.controls.gruppemal.controls.navn" data-testid="malnavn-felt">
            @if (skjema.controls.gruppemal.controls.navn.hasError('maxlength')) {
              <mat-error data-testid="maxlength">{{ skjema.controls.gruppemal.controls.navn.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ 'Beskrivelse'|translate }}</mat-label>
            <textarea matInput [formControl]="skjema.controls.gruppemal.controls.beskrivelse" data-testid="malbeskrivelse-felt"></textarea>
            @if (skjema.controls.gruppemal.controls.beskrivelse.hasError('maxlength')) {
              <mat-error data-testid="maxlength">{{ skjema.controls.gruppemal.controls.beskrivelse.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
            }
          </mat-form-field>
        }
        <mat-form-field>
          <mat-label>{{ 'Møtenavn'|translate }}</mat-label>
          <input matInput [formControl]="skjema.controls.moetenavn" data-testid="møtenavn-felt">
          @if (skjema.controls.moetenavn.hasError('maxlength')) {
            <mat-error data-testid="maxlength">{{ skjema.controls.moetenavn.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'Gruppenavn'|translate }}</mat-label>
          <input matInput [formControl]="skjema.controls.tittel" data-testid="tittel-felt">
          @if (skjema.controls.tittel.hasError('maxlength')) {
            <mat-error data-testid="maxlength">{{ skjema.controls.tittel.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
          }
        </mat-form-field>
        @if (!skjema.value.erMal) {
          <mat-form-field>
            <mat-label>{{ 'Organisasjonsnavn'|translate }}</mat-label>
            <input matInput [formControl]="skjema.controls.organisasjonsnavn" data-testid="organisasjonsnavn-felt">
            @if (skjema.controls.organisasjonsnavn.hasError('maxlength')) {
              <mat-error data-testid="maxlength">{{ skjema.controls.organisasjonsnavn.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
            }
          </mat-form-field>
        }
        <div class="i18nvalg">
          <mat-form-field>
            <mat-label>{{ 'Standard språk'|translate }}</mat-label>
            <lokale-velger [skjemakontroll]="skjema.controls.spraak"/>
            @if (!skjema.controls.tidssone.hasError('ugyldig')) {
            <mat-hint>{{'Standard språk og tidssone benyttes i genererte PDF-rapporter og eposter'|translate}}</mat-hint>
            }
          </mat-form-field>
          <mat-form-field class="tidssone">
            <mat-label>{{ 'Standard tidssone'|translate }}</mat-label>
            <tidssone-velger [skjemakontroll]="skjema.controls.tidssone"/>
            @if (skjema.controls.tidssone.hasError('ugyldig')) {
              <mat-error>{{'Ugyldig tidssone'|translate}}</mat-error>
            }
          </mat-form-field>
        </div>

        <inline-melding type="info" voksHorisontalt="true">
          <div>{{'Møter i denne gruppen vil hete'|translate}}:</div>
          <span class="skjemaverdi">{{skjema.value.moetenavn}}</span>
          @if(skjema.value.moetenavn == ''){<span class="skjemaverdi-mangler">{{'møtenavn'|translate}}</span>}
          {{'i'|translate}}
          <span class="skjemaverdi">{{skjema.value.tittel}}</span>
          @if(skjema.value.tittel == ''){<span class="skjemaverdi-mangler">{{'gruppenavn'|translate}}</span>}
          {{'i'|translate}}
          @if(skjema.value.erMal || skjema.value.organisasjonsnavn == ''){
            <span class="skjemaverdi-mangler">{{'avtale'|translate}}</span>
          } @else {
            <span class="skjemaverdi">{{skjema.value.organisasjonsnavn}}</span>
          }
        </inline-melding>
      </fieldset>
    </div>

    <inline-skjema-handlinger navigasjonforhindret-flash>
      <div class="handlinger">
        <button mat-stroked-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
        <button mat-raised-button type="submit" color="primary" cdkFocusInitial [visSpinner]="lagrer()" [disabled]="lagrer() || skjema.invalid" spinnerTekst="{{'Lagrer...'|translate}}">
          {{ "Lagre"|translate }}
        </button>
      </div>
      <mat-slide-toggle *kreverTilgangsrolleBruker="'administrator'" [formControl]="skjema.controls.erMal" data-testid="erGruppemal-felt">{{ 'Dette er en malgruppe'|translate }}</mat-slide-toggle>
    </inline-skjema-handlinger>
  </inline-skjema>
</form>

